import React from "react";

type KpiStatCardProps = {
  label: string;
  value: number | string;
  growth?: string;
  helper: string;
  icon: React.ReactNode;
};

const KpiStatCard = ({ label, value, growth, helper, icon }: KpiStatCardProps) => {
  return (
    <article className="rounded-[8px] border border-light-grey bg-white p-3.5">
      <p className="text-xs font-medium text-dark-black">{label}</p>
      <div className="mt-2 flex items-center gap-2">
        {icon}
        <p className="text-sm font-semibold text-dark-black">{value}</p>
        {growth ? (
          <span className="rounded-[4px] bg-bright-green/20 px-1.5 py-0.5 text-[10px] text-mainColor">
            {growth}
          </span>
        ) : null}
      </div>
      <p className="mt-2 text-[10px] text-dark-grey">{helper}</p>
    </article>
  );
};

export default KpiStatCard;

